import * as React from 'react';
import { Button } from 'react-bootstrap';
import { Translate } from '../../../../../shared/LanguageService';
import { IAttachments } from '../Types';

interface IProps {
    items: IAttachments;
    download: (WarmStorageReference: string) => void;
    index: number;
}

const CommunicationAttachmentsListRow = (props: IProps) => {
    return (
        <tr>
            <td style={{ border: '0px' }}> {props.items.fileName}</td>
            <td style={{ border: '0px' }}>
                <Button
                    className="pull-right btn-group-sm"
                    onClick={() => props.download(props.items.warmStorageReference)}
                    bsSize="small"
                    bsStyle="success"
                >
                    <i className="material-icons">file_download</i>
                    {Translate(
                        'view-order/basic-order-info/modal/view-communication-details/download-files'
                    )}
                </Button>
            </td>
        </tr>
    );
};

export default CommunicationAttachmentsListRow;
